import { WishlistApp } from "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.18.5/wishlist-app.js";
export const createApp = ({ settings, config, locale }) => {
  if (window.WishlistKing) {
    return;
  }

  const app = new WishlistApp({
    config,
    settings,
    locale,
    dependencies: [
      "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.18.5/components/wishlist.css",
      "//perfectlocks.in/cdn/shop/t/17/assets/wishlist-king-custom.css?v=124945538255378970191693287650",
      "//perfectlocks.in/cdn/shop/t/17/assets/wishlist-king-components.js?v=113727407625479029511693287650",
    ],
  });

  app.events.once("wk:app:load-scripts:success", () => {
    initEvents(app);
    initComponents(app);
  })

  return app;
};

const initComponents = ({ theme, routes }) => {
  // Header link
  theme.watch(
    {
      selector: `.wk-wishlist-link`,
    },
    (target) => {
      theme.createHeadlessComponent("wishlist-link", {
        host: target,        
      });
    }
  );

  // Product page
  theme.watch(
    {
      selector: `.wk-wishlist-button`,
      pageType: ["product"],
    },
    (target) => {
      theme.createHeadlessComponent("wishlist-button", {
        host: target,
        dataset: {
          productHandle: theme.getProductHandle(document.location.href),
          variantId: theme.getVariantId(document.location.href),
        },
      });
    }
  );

  // Wishlist page
  theme.watch(
    {
      selector: "#wishlist-page",
    },
    (target) => {
      target.replace(
        theme.createComponent("wishlist-page", {
          dataset: {
            wishlistId: theme.getWishlistId(window.location.pathname),
          },
        })
      );
    }
  );
};

const initEvents = (app) => {
  app.events.subscribe("wk:wishlist:add-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:add-all-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:login-required", (event) => {
    const ignoreActions = ["wishlist:private:load"];
    if (!ignoreActions.includes(event.data.action)) {
      window.location.href = app.routes.accountLoginUrl;
    }
  });
};
